import { z } from "zod";

export const UserRole = {
  Patient: "patient",
  Doctor: "doctor",
  Admin: "admin",
} as const;

export const userRoleSchema = z.enum(UserRole);
export type UserRole = z.infer<typeof userRoleSchema>;

export interface AuthSession {
  userId: string;
  fullName: string;
  email: string | null;
  role: UserRole;
  profilePicture?: string | null;
}
